import * as Yup from 'yup';
import * as yup from 'yup';
import { messages } from 'app/config/constants';

export const caseRegistryFormV2Validation = Yup.object({
  caseGroup: yup.array().min(1, messages.MANDATORY_FIELD),
  caseCategory: yup.array().min(1, messages.MANDATORY_FIELD),
  description: Yup.string().required(messages.MANDATORY_FIELD),
});

export const caseRegistryFormValidation = Yup.object({
  caseCategory: yup.array().min(1, messages.MANDATORY_FIELD),
  description: Yup.string().required(messages.MANDATORY_FIELD),
});
